export default __webpack_public_path__ + "static/media/meditation.5facbe12.png";